module.exports = __webpack_public_path__ + "static/media/CheckedRadioImg.63c118eb.svg";